import L from 'leaflet';
import { pinIconSvg } from '../../../utils/pinIconSvg.js';

/**
 * Returns a Leaflet DivIcon rendered as an SVG "location pin".
 * - `fillColor` is taken directly from existing marker color logic (status/event colors)
 * - keeps a white stroke for contrast (matching the old circle marker outline)
 * - SVG markup is built by the pure `pinIconSvg` helper; this only wraps it for Leaflet
 */
export function createLeafletPinIcon({
  fillColor,
  sizePx = 28,
  strokeColor = '#fff',
  strokeWidth = 0.5,
  className = '',
  variant = 'solid',
} = {}) {
  const { svg, size } = pinIconSvg({ fillColor, sizePx, strokeColor, strokeWidth, variant });

  return L.divIcon({
    className: `leaflet-pin-icon ${className}`.trim(),
    html: svg,
    iconSize: [size, size],
    iconAnchor: [size / 2, size],
    popupAnchor: [0, -size + 4],
  });
}
